import { render } from "./LobbySkeleton.vue?vue&type=template&id=2ad59ec8&scoped=true"
import script from "./LobbySkeleton.vue?vue&type=script&lang=js"
export * from "./LobbySkeleton.vue?vue&type=script&lang=js"

import "./LobbySkeleton.vue?vue&type=style&index=0&id=2ad59ec8&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad59ec8"]])

export default __exports__